import "../../../index66.css";
import { jsxs as v, jsx as c } from "react/jsx-runtime";
import { i as n } from "../../../type-BFTbooL7.js";
import { _ as o } from "../../../cs-piwRuCFZ.js";
const p = "_chart-point_aqsix_1", x = "_point_aqsix_7", m = "_active_aqsix_14", d = "_hovered_aqsix_18", u = "_point-outline_aqsix_23", f = "_hoverable_aqsix_35", t = {
  chartPoint: p,
  point: x,
  active: m,
  hovered: d,
  pointOutline: u,
  hoverable: f
};
function P(s) {
  const {
    className: r,
    hovered: l,
    hoverable: _,
    active: a,
    x: e,
    y: i,
    children: h
  } = s;
  return n(e) || n(i) ? null : /* @__PURE__ */ v(
    "g",
    {
      className: o(
        t.chartPoint,
        _ && t.hoverable,
        r
      ),
      children: [
        /* @__PURE__ */ c(
          "circle",
          {
            className: o(
              t.pointOutline,
              a && t.active
            ),
            cx: e,
            cy: i
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            className: o(
              t.point,
              a && t.active,
              l && t.hovered
            ),
            cx: e,
            cy: i
          }
        ),
        h
      ]
    }
  );
}
export {
  P as default
};
